module.exports = "#btnContainer {\r\n    margin-top: 22px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/salaries/payroll-form/payroll-form.component.css
// module id = ./src/app/components/salaries/payroll-form/payroll-form.component.css
// module chunks = main